import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { colors } from "../../theme/colors";

// Matches the rules Cognito enforces for a new password:
// min length 6 (amplify password policy) and the InvalidPasswordException
// message: 1 capital letter, 1 number, and a special character. Lowercase
// is required alongside the capital letter.
const COGNITO_SYMBOL = /[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/;

export const PASSWORD_RULES = [
  {
    id: "length",
    label: "At least 6 characters",
    test: (password) => password.length >= 6,
  },
  {
    id: "capital",
    label: "One capital letter",
    test: (password) => /[A-Z]/.test(password),
  },
  {
    id: "lowercase",
    label: "One lowercase letter",
    test: (password) => /[a-z]/.test(password),
  },
  {
    id: "number",
    label: "One number",
    test: (password) => /[0-9]/.test(password),
  },
  {
    id: "special",
    label: "One special character",
    test: (password) => COGNITO_SYMBOL.test(password),
  },
];

export function passwordMeetsRequirements(password) {
  return PASSWORD_RULES.every((rule) => rule.test(password || ""));
}

export default function PasswordRequirements({ password }) {
  const value = password || "";

  return (
    <Box
      component="ul"
      aria-label="Password requirements"
      sx={{
        listStyle: "none",
        m: 0,
        p: 0,
        display: "flex",
        flexDirection: "column",
        gap: 0.35,
      }}
    >
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(value);
        return (
          <Box
            component="li"
            key={rule.id}
            aria-label={`${rule.label}, ${met ? "met" : "not met"}`}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              color: met ? colors.gold : colors.muted,
              fontSize: "0.75rem",
              lineHeight: 1.3,
            }}
          >
            <Box
              aria-hidden
              sx={{
                width: 14,
                height: 14,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {met ? (
                <CheckIcon sx={{ fontSize: 14 }} />
              ) : (
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    border: "1px solid currentColor",
                    boxSizing: "border-box",
                  }}
                />
              )}
            </Box>
            <Box component="span" aria-hidden>
              {rule.label}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
